import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import all translation files statically
import en from './locales/en/translation.json';
import ar from './locales/ar/translation.json';
import zh from './locales/zh/translation.json';
import fr from './locales/fr/translation.json';
import de from './locales/de/translation.json';
import hi from './locales/hi/translation.json';
import it from './locales/it/translation.json';
import ja from './locales/ja/translation.json';
import ko from './locales/ko/translation.json';
import pt from './locales/pt/translation.json';
import ru from './locales/ru/translation.json';
import es from './locales/es/translation.json';
import tr from './locales/tr/translation.json';
import nl from './locales/nl/translation.json';
import pl from './locales/pl/translation.json';
import vi from './locales/vi/translation.json';
import id from './locales/id/translation.json';
import th from './locales/th/translation.json';
import uk from './locales/uk/translation.json';
import ro from './locales/ro/translation.json';
import el from './locales/el/translation.json';
import cs from './locales/cs/translation.json';
import sv from './locales/sv/translation.json';
import hu from './locales/hu/translation.json';
import fi from './locales/fi/translation.json';
import da from './locales/da/translation.json';
import no from './locales/no/translation.json';
import he from './locales/he/translation.json';

const resources = {
  en: { translation: en },
  ar: { translation: ar },
  zh: { translation: zh },
  fr: { translation: fr },
  de: { translation: de },
  hi: { translation: hi },
  it: { translation: it },
  ja: { translation: ja },
  ko: { translation: ko },
  pt: { translation: pt },
  ru: { translation: ru },
  es: { translation: es },
  tr: { translation: tr },
  nl: { translation: nl },
  pl: { translation: pl },
  vi: { translation: vi },
  id: { translation: id },
  th: { translation: th },
  uk: { translation: uk },
  ro: { translation: ro },
  el: { translation: el },
  cs: { translation: cs },
  sv: { translation: sv },
  hu: { translation: hu },
  fi: { translation: fi },
  da: { translation: da },
  no: { translation: no },
  he: { translation: he },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: Object.keys(resources),
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n; 